import React, { useState } from "react";
import { Button, App, Space, Input, Empty } from "antd";
import { useNotification } from "hook/notification/useNotification";
//
//component
//redux
//selector
//actions
//function
//str

//
const DevScreen = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleGenerate = () => {
    message.success("Bắn thử được k");
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return (
    <div
      className="content-no-bg"
      style={{ width: "100%", padding: 20, minHeight: "100vh" }}
    >
      {" "}
      <Button onClick={handleGenerate}>Bắn message</Button>
    </div>
  );
};
export default DevScreen;
